import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-middleton',
  styleUrl: './middleton.css',
  templateUrl: './middleton.html',
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class -- Angular requires a decorated component class.
export class Middleton {}
